// src/components/UploadForm.js

import React, { useEffect, useState } from "react";
import axios from "axios";

import Loader from "../../Layout/Loader";
import upload from "./upload.png";

import "./upload.css"; 

const Upload = ({ setChooseBox }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [newFileName, setNewFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setError("");
    setSuccess("");
  };

  const handleNameChange = (event) => {
    setNewFileName(event.target.value);
    setError("");
    setSuccess("");
  };

  const handleSaveFile = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      setError("Please select a file.");
      return;
    }
    if (!newFileName) {
      setError("Please enter a new file name.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("fileName", newFileName);

    try {
      setLoading(true);
      await axios.post(process.env.REACT_APP_BACKEND + "/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setSuccess("File uploaded successfully.");
    } catch (err) {
      console.log(err);
      setError(err.response.data || "Error uploading file.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      setSuccess("");
      setError("");
      setSelectedFile(null);
      setNewFileName("");
    }
  }, [loading]);

  return (
    <>
      {loading && <Loader />}
      <div className="upload-container">
        <form onSubmit={handleSaveFile}>
          <h1>Upload and Rename PDF</h1>
          <label htmlFor="upload-hidden">
            <div className="upload-box">
              {selectedFile ? (
                <h1>Selected</h1>
              ) : (
                <>
                  <img src={upload} alt="not found" />
                  <h1 className="select">Please Select a file</h1>
                </>
              )}
            </div>
          </label>
          <input
            id="upload-hidden"
            hidden
            type="file"
            accept="application/pdf"
            onChange={handleFileChange}
            required
          />
          <input
            required
            type="text"
            value={newFileName}
            onChange={handleNameChange}
            placeholder="Enter new file name"
          />
          <button type="submit">Save File</button>
        </form>
        {error && <p className="text-red-500 font-semibold">{error}</p>}
        {success && <p className="text-fuchsia-800 font-semibold">{success}</p>}
        <button className="done-button" onClick={() => setChooseBox("")}>
          Done
        </button>
      </div>
    </>
  );
};

export default Upload;
